import { freshChatService } from './freshChatService';
import uuidv4 from 'uuid/v4';
import { chatApiService } from './chatApiService'

export const Chat =  {
  methods: {
    initializeChat(restoreId, externalId,  theme, businessProfileId, businessName, user, hideChatButton){
      let chatUserId = uuidv4();

      let userProperties = {
        email: user ? user.emailAddress : null,
        userName: user ? `${user.firstName} ${user.lastName}` : null,
        userId: user ? user.id : null
      }
      let selectedBusinessProfile = user && user.businessProfiles && user.businessProfiles.find(
        (bp) => bp.id === businessProfileId
      );
      if(selectedBusinessProfile){
        userProperties.firstName = `${selectedBusinessProfile.name} - ${selectedBusinessProfile.id}`;
        userProperties.businessProfileId = selectedBusinessProfile.id;
        userProperties.businessProfileName = selectedBusinessProfile.name;
      } else if (businessName){
        userProperties.firstName = businessName;
      } else {
        userProperties.firstName = `Bizgain User - ${chatUserId}`
      }

      let widgetSettings = {
        headerProperty: {
          hideChatButton: hideChatButton,
          direction: 'rtl',
          backgroundColor: theme.primary,
          foregroundColor: theme.white
        }
      }
      //Initializes freshchat window
      freshChatService.initializeWidget(
        restoreId,
        externalId || `Business-${chatUserId}`,
        userProperties,
        widgetSettings
      );
    },
    toggleChatPanel() {
      if (!freshChatService.isOpen()) {
        freshChatService.open();
      }else{
        freshChatService.close();
      }
    },
    async updateUserProperties(user) {
      await freshChatService.updateUserProperties(user);
    },
    destroyChatPanel() {
      freshChatService.destoryWidget()
    },
    closeChatPanel() {
      freshChatService.close();
    },
    openChatPanel() {
      freshChatServicec.open();
    },
    isChatPanelOpen() {
      return freshChatService.isOpen();
    },
    async storeChatIdentifiers(businessProfileId, restoreId, externalId){
      await chatApiService.storeChatIdentifiers(businessProfileId, restoreId, externalId);
    }
  }
}